module.exports = __webpack_public_path__ + "static/media/Gordon Baty.91d8daf8.png";